import React from "react";
import Template1CS from "./Template1CS";
import Template2CS from "./Template2CS";
import Template3CS from "./Template3CS";
import Template4CS from "./Template4CS";
import Template5CS from "./Template5CS";
import Template6CS from "./Template6CS";
import Template7CS from "./Template7CS";
import Template8CS from "./Template8CS";
import Template9CS from "./Template9CS";

const ConfinedSpaceTemplate = ({ permitDetails, isSidebarExpanded }) => {

  const {
    checklistItems = [{}],
    workDetails = {},
    form_data: formData = {},
    hazardsPrecautions = [{}],
    signatures = [{}],
    clearanceRenewal= [{}],
    permitClosure= {},
    generalInstructions = [],
  } = permitDetails || {};

  console.log("permitDetails in ColdWorkPermitTemplate:", permitDetails);
  console.log("Checklist in ColdWorkPermitTemplate:", checklistItems); // Updated here
  console.log("workDetails in ColdWorkPermitTemplate:", workDetails);
  console.log("formData in ColdWorkPermitTemplate:", formData);

  return (
    // <div className="template-container">
    <div className="cs-work-template">
      <div id="section1">
        <Template1CS workDetails={workDetails}/>
        <Template2CS
          workDetails={workDetails}
          isSidebarExpanded={isSidebarExpanded}
        />
        <Template3CS />
        <Template4CS
          checklist={checklistItems} // Passing checklistItems correctly
          isSidebarExpanded={isSidebarExpanded}
        />
        <Template5CS
          hazardsPrecautions={hazardsPrecautions}
          isSidebarExpanded={isSidebarExpanded}
        />
        <Template6CS
          signatures={signatures} formData={formData} workDetails={workDetails} permitDetails={permitDetails}
          isSidebarExpanded={isSidebarExpanded}
        />
      </div>
      <div id="section2">
        <Template7CS
          hazardsPrecautions={hazardsPrecautions}
          isSidebarExpanded={isSidebarExpanded}
        />
        <Template8CS  clearanceRenewal={clearanceRenewal} workDetails={workDetails}  isSidebarExpanded={isSidebarExpanded} />
        <Template9CS permitClosure={permitClosure} workDetails={workDetails}/>
      </div>
    </div>
    // </div>
  );
};

export default ConfinedSpaceTemplate;